/**
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2020, Zumper
 * @description  getInputValue.js
 */

import type { AutocompleteApiResult } from '@zcode/bizos'

export function getInputValue(result: null | undefined): undefined
export function getInputValue(result: AutocompleteApiResult): string
export function getInputValue(result: AutocompleteApiResult | null | undefined): string | undefined
export function getInputValue(result: AutocompleteApiResult | null | undefined) {
  if (!result) {
    return undefined
  }
  const { hood, city, state } = result
  const cityState = `${city}, ${state}`
  return hood ? `${hood}, ${cityState}` : cityState
}
